import {useContext, useEffect, useState} from 'react'
import ApiService from '../../../../common/ApiCalls'
import {useParams} from 'react-router-dom'
import {GlobalContext} from '../../../../services/context/DataContext'

const useTabHeader = () => {
    const { selectedText, tabsData } = useContext(GlobalContext)
    const [, setSelectedLoc] = selectedText
    const [tabs,] = tabsData
    const [headerData, setHeaderData] = useState({})
    const {id} = useParams()

    const showMap = (address_coordinates) => {
        const url = `https://www.google.com/maps/dir//${address_coordinates}`
        window.open(url)
    }

    const getData = async () => {
        try {
            const res = await ApiService().getQuickView(id)
            setSelectedLoc(res.data.loc_name)
            setHeaderData(res.data)
        } catch (e) {
            console.log(e)
        }
    }

    const hasAtLeastOneTabPermission = () => {
      for(let i = 0; i < tabs.length; i++){
        if(!tabs[i].isDisabled){
          return true
        }
      }
      return false
    }

    useEffect(()=>{
        if(id&&hasAtLeastOneTabPermission()){
            getData()
        }
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [tabs,id])

    return {showMap, headerData}
}

export default useTabHeader
